<script lang="ts">var _a, _b, _c;
import TextInput from "../TextInput/TextInput.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore, getHrefForMediaItem } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
$: key = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.key) || 'generic-text-input-key';
$: placeholder = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.placeholder) || 'Text Input';
$: required = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.required) || false;
let val;
const handleChange = (e) => {
    val = e.target.value;
    console.log(placeholder + ': ', key, val);
    tabContext.setParam(key, val);
};
</script>

<CardBase {element}>
    <div class="generic-text-input-field-wrapper">
        <TextInput placeholder={placeholder + ((required)? '*' : '')} value={val} onChange={handleChange} />
    </div>
</CardBase>

<style>.generic-text-input-field-wrapper {
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
}</style>
    